<template>
  <Page class="page" :filters="filters">
    <div class="title">{{ $t('report.exportIntroduction') }}</div>

    <div class="content">
      <div class="section">
        <div class="section-title">{{ $t('report.exportIntroductionExplanation.travelTime.title') }}</div>

        <div v-if="study.public_transport_provider === 1" class="item">
          <div class="item-title">
            {{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.title') }}
          </div>
          <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.googleMaps.1') }}</span>
          <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.googleMaps.2') }}</span>
          <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.googleMaps.3') }}</span>
          <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.googleMaps.4') }}</span>
        </div>

        <div v-if="study.public_transport_provider === 2 || !study.public_transport_provider" class="item">
          <div class="item-title">
            {{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.title') }}
          </div>
          <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.navitia.1') }}</span>
          <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.navitia.2') }}</span>
          <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.navitia.3') }}</span>
          <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.navitia.4') }}</span>
        </div>

        <div v-if="study.public_transport_provider === 3" class="item">
          <div class="item-title">
            {{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.title') }}
          </div>
          <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.travelTime.1') }}</span>
          <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.travelTime.2') }}</span>
          <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.travelTime.3') }}</span>
          <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.travelTime.4') }}</span>
        </div>

        <div v-if="study.private_transport_provider === 1 || !study.private_transport_provider" class="item">
          <div class="item-title">
            {{
              study.withWalkingTimes
                ? $t('report.exportIntroductionExplanation.travelTime.privateTransport.title')
                : $t('report.exportIntroductionExplanation.travelTime.privateTransport.titleNoWalk')
            }}
          </div>
          <span>{{
            study.withWalkingTimes
              ? $t('report.exportIntroductionExplanation.travelTime.privateTransport.googleMaps.1')
              : $t('report.exportIntroductionExplanation.travelTime.privateTransport.googleMaps.1NoWalk')
          }}</span>
          <span>{{ $t('report.exportIntroductionExplanation.travelTime.privateTransport.googleMaps.2') }}</span>
        </div>

        <div v-if="study.private_transport_provider === 3" class="item">
          <div class="item-title">
            {{ $t('report.exportIntroductionExplanation.travelTime.privateTransport.title') }}
          </div>
          <span>{{ $t('report.exportIntroductionExplanation.travelTime.privateTransport.travelTime.1') }}</span>
          <span>{{ $t('report.exportIntroductionExplanation.travelTime.privateTransport.travelTime.2') }}</span>
          <span>{{ $t('report.exportIntroductionExplanation.travelTime.privateTransport.travelTime.3') }}</span>
        </div>
      </div>

      <div class="section">
        <div class="section-title">{{ $t('report.exportIntroductionExplanation.impactOnCollaborators.title') }}</div>
        {{ $t('report.exportIntroductionExplanation.impactOnCollaborators.text1') }}<br />
        {{ $t('report.exportIntroductionExplanation.impactOnCollaborators.text2') }}<br />
        {{ $t('report.exportIntroductionExplanation.impactOnCollaborators.text3') }}<br />

        <div class="section-title">{{ $t('report.exportIntroductionExplanation.outlier.title') }}</div>
        {{ $t('report.exportIntroductionExplanation.outlier.text1', { duration: study.sensitive_case_duration || 45 }) }}<br />

        <div class="section-title">{{ $t('report.exportIntroductionExplanation.environmentalImpact.title') }}</div>
        <template v-if="!(study.public_transport_provider === 3 || study.private_transport_provider === 3)">
          <span v-if="studyIsInFrance">{{ $t('report.exportIntroductionExplanation.environmentalImpact.text2France') }}</span>
          <span v-else>{{ $t('report.exportIntroductionExplanation.environmentalImpact.text2') }}</span>
          <span>{{ $t('report.exportIntroductionExplanation.environmentalImpact.text3') }}</span>
        </template>

        <template v-if="study.public_transport_provider === 3 || study.private_transport_provider === 3">
          <span>{{ $t('report.exportIntroductionExplanation.environmentalImpact.text1') }}</span>
        </template>

        <div v-if="study.public_transport_provider === 3 || study.private_transport_provider === 3" class="trasport-co2">
          <div class="transport-column">
            {{ $t('report.exportIntroductionExplanation.environmentalImpact.transports.1') }}<br />
            {{ $t('report.exportIntroductionExplanation.environmentalImpact.transports.2') }}<br />
            {{ $t('report.exportIntroductionExplanation.environmentalImpact.transports.3') }}<br />
          </div>

          <div class="transport-column">
            {{ $t('report.exportIntroductionExplanation.environmentalImpact.transports.4') }}<br />
            {{ $t('report.exportIntroductionExplanation.environmentalImpact.transports.5') }}<br />
          </div>
        </div>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Report/BasePage';

export default {
  name: 'IntroductionExplanationPage',

  components: {
    Page,
  },

  props: {
    study: {
      type: Object,
      required: false,
      default: () => ({}),
    },

    export: {
      type: Object,
      required: false,
      default: () => ({}),
    },

    filters: {
      type: String,
      required: false,
      default: null,
    },
  },

  computed: {
    studyIsInFrance() {
      return this.study.countries?.includes('France');
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';

.page {
  padding: 48px 80px;
  box-sizing: border-box;

  .title {
    display: flex;
    flex-direction: column;
    font-size: 32px;
    font-weight: 600;
    color: #3c3c3b;
    margin-bottom: 16px;

    &::after {
      content: '';
      margin: 8px 0;
      width: 64px;
      height: 4px;
      border-radius: 4px;
      background: colors.$main-color;
    }
  }

  .subtitle {
    display: flex;
    flex-direction: column;
    font-size: 24px;
    font-weight: 200;
    color: #3c3c3b;
    margin-bottom: 16px;
  }

  .content {
    display: flex;

    .section {
      width: 48%;
      margin-right: 4%;

      &:last-child {
        margin-right: 0;
      }

      .section-title {
        font-weight: bold;
        margin-top: 24px;
        margin-bottom: 8px;
        color: #3c3c3b;

        &:first-child {
          margin-top: 0;
        }
      }

      .item {
        margin-top: 12px;

        &:first-child {
          margin-top: 0;
        }

        .item-title {
          position: relative;
          font-weight: bold;
          margin-bottom: 4px;

          &::after {
            content: '';
            margin: 8px 0;
            width: 64px;
            height: 4px;
            border-radius: 4px;
            background: colors.$main-color;
          }
        }

        span {
          display: block;
        }

        .item-transport {
          margin-top: 4px;
          margin-left: 16px;

          &:nth-child(2n) {
            margin-bottom: 8px;
          }

          span {
            font-weight: 600;
          }
        }
      }
    }
  }
}
</style>
